import { createParser } from 'nuqs';

export const AGENT_PARAM = 'agent';

export const NEW_CONVERSATION_KEY = 'new';

const AGENT_PARAM_VALUE_PATTERN = /^[A-Za-z0-9_-]{1,64}$/;

export const agentParamParser = createParser({
  parse: (value) => (AGENT_PARAM_VALUE_PATTERN.test(value) ? value : null),
  serialize: (value: string) => value,
}).withOptions({ shallow: false });

export const agentParamOfSession = (sessionId: string | null): string =>
  sessionId ?? NEW_CONVERSATION_KEY;

export const sessionIdOfAgentParam = (agent: string): string | null =>
  agent === NEW_CONVERSATION_KEY ? null : agent;

export const agentParamOfSearch = (search: string): string | null => {
  const value = new URLSearchParams(search).get(AGENT_PARAM);
  return value !== null && AGENT_PARAM_VALUE_PATTERN.test(value) ? value : null;
};

export const withoutAgentParam = (search: string): string => {
  const params = new URLSearchParams(search);
  if (!params.has(AGENT_PARAM)) return search;
  params.delete(AGENT_PARAM);
  const rest = params.toString();
  return rest ? `?${rest}` : '';
};
